import React from 'react';
import Link from 'next/link';

import cx from 'classnames';

import { useNavigation } from 'hooks/navigation/useNavigation';

import s from './OrganicNavigation.module.css';

const OrganicNavItemHome = () => {
  const { businessName } = useNavigation();

  if (!businessName) {
    return <h2>Home</h2>;
  }

  return (
    <div
      className={cx(s.businessName, {
        [s.longName]: businessName.length > 10,
      })}
    >
      <Link href="/">{businessName}</Link>
    </div>
  );
};

export { OrganicNavItemHome };
